"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubText = exports.PreText = exports.AmountSubText = exports.Amount = exports.Currency = exports.AmountWrapper = exports.PriceWrapper = exports.SpinnerWrapper = exports.StyledPrice = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledPrice = _styledComponents.default.div.withConfig({
  displayName: "Pricestyles__StyledPrice",
  componentId: "sc-11c9l9d-0"
})(["position:relative;width:100%;"]);

exports.StyledPrice = StyledPrice;

var SpinnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "Pricestyles__SpinnerWrapper",
  componentId: "sc-11c9l9d-1"
})(["position:absolute;top:", ";left:", ";right:", ";bottom:", ";display:flex;flex-direction:column;justify-content:center;align-items:center;.c-price-loading-message{font-weight:", ";}"], function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.primaryNormal;
});

exports.SpinnerWrapper = SpinnerWrapper;

var PriceWrapper = _styledComponents.default.div.withConfig({
  displayName: "Pricestyles__PriceWrapper",
  componentId: "sc-11c9l9d-2"
})(["margin:", ";display:flex;flex-direction:column;justify-content:center;align-items:center;opacity:", ";"], function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.isLoading ? 0 : 1;
});

exports.PriceWrapper = PriceWrapper;

var AmountWrapper = _styledComponents.default.div.withConfig({
  displayName: "Pricestyles__AmountWrapper",
  componentId: "sc-11c9l9d-3"
})(["display:grid;grid-template-columns:auto auto auto;grid-area:amount;align-items:baseline;& *{color:", ";font-weight:", ";}.c-price-amount-subtext{font-size:", ";padding-left:.75rem;}"], function (props) {
  return props.theme.c_foreground_primary;
}, function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return props.theme.fontLarge;
});

exports.AmountWrapper = AmountWrapper;

var Currency = _styledComponents.default.span.withConfig({
  displayName: "Pricestyles__Currency",
  componentId: "sc-11c9l9d-4"
})(["font-size:2rem;padding-right:.1rem;position:relative;top:-1.1875rem;@media only screen and (min-width:", "){top:-1.9rem;}"], function (props) {
  return props.theme.smallBreak;
});

exports.Currency = Currency;

var Amount = _styledComponents.default.span.withConfig({
  displayName: "Pricestyles__Amount",
  componentId: "sc-11c9l9d-5"
})(["font-size:3.5rem;@media only screen and (min-width:", "){font-size:4.5rem;}"], function (props) {
  return props.theme.smallBreak;
});

exports.Amount = Amount;

var AmountSubText = _styledComponents.default.span.withConfig({
  displayName: "Pricestyles__AmountSubText",
  componentId: "sc-11c9l9d-6"
})(["font-size:", ";padding-left:.75rem;"], function (props) {
  return props.theme.fontLarge;
});

exports.AmountSubText = AmountSubText;

var PreText = _styledComponents.default.p.withConfig({
  displayName: "Pricestyles__PreText",
  componentId: "sc-11c9l9d-7"
})(["grid-area:pretext;padding-bottom:1.5rem;text-align:center;"]);

exports.PreText = PreText;

var SubText = _styledComponents.default.p.withConfig({
  displayName: "Pricestyles__SubText",
  componentId: "sc-11c9l9d-8"
})(["grid-area:componentSubtext;padding-top:1rem;text-align:center;"]);

exports.SubText = SubText;